export default __webpack_public_path__ + "static/media/ic-contact.7c483183.webp";